import React from "react";

import HomePageWelcome from "./components/Welcome/Welcome";
import OurVision from "./components/OurVision/OurVision";
import HomePageOurSchool from "./components/OurSchool/HomePageOurSchool";
import Awards from "./components/Awards/Awards";
import HomePageTheBilingualProject from "./components/TheBilingualProject/HomePageTheBilingualProject";
const HomePage = () => {
  return (
    <React.Fragment>

        <HomePageWelcome/>
        <OurVision/>
        <HomePageOurSchool/>
        <Awards/>
        <HomePageTheBilingualProject/>

 
    </React.Fragment>
  );
};

export default HomePage;
